import request, { Variables } from 'graphql-request';
import { RequestOptions } from 'graphql-request/src/types';
import { getShopifyStorefrontApiHeaders, SHOPIFY_STOREFRONT_API_URL } from '@portal/config/base';
import { StoreCode } from '../../schema/storeCode';

type Options<T = any, V extends Variables = Variables> = {
  storeCode: StoreCode;
} & RequestOptions<V, T>;

export function shopifyStorefrontRequest<T, V extends Variables>(options: Options<T, V>) {
  const { storeCode, variables, document } = options;

  return request({
    url: SHOPIFY_STOREFRONT_API_URL[storeCode],
    document,
    variables,
    requestHeaders: getShopifyStorefrontApiHeaders(storeCode)
  });
}
